import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Table, Button, Form, Badge, InputGroup } from 'react-bootstrap';
import { FaCheckCircle, FaSearch, FaTimesCircle } from 'react-icons/fa';
import axios from 'axios';

const GymAttendance = () => {
  const [attendance, setAttendance] = useState([]);
  const [members, setMembers] = useState([]);
  const [date, setDate] = useState(new Date().toISOString().split('T')[0]);
  const [search, setSearch] = useState('');
  const [stats, setStats] = useState({ present: 0, absent: 0, total: 0 });
  const [loading, setLoading] = useState(true);

  console.log('Current date:', date);
  console.log('Members:', members.length);
  console.log('Attendance records:', attendance.length);

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      const membersList = await fetchMembers();
      setLoading(false);
    };
    loadData();
  }, []);

  useEffect(() => {
    if (members.length > 0) {
      fetchAttendance();
    } else {
      // Reset stats if no members
      setStats({ present: 0, absent: 0, total: 0 });
    }
  }, [date, search, members.length]);

  const fetchMembers = async () => {
    try {
      const res = await axios.get('/api/gym/members');
      const activeMembers = Array.isArray(res.data) ? res.data.filter(m => m.isActive) : [];
      setMembers(activeMembers);
      return activeMembers;
    } catch (err) {
      console.error('Error fetching members:', err);
      setMembers([]);
      return [];
    }
  };

  const fetchAttendance = async () => {
    try {
      console.log('=== FETCHING ATTENDANCE ===');
      console.log('Date:', date);
      console.log('Search:', search);
      console.log('Members count:', members.length);
      
      const res = await axios.get('/api/gym/attendance', { params: { date, search } });
      const records = Array.isArray(res.data) ? res.data : [];
      
      console.log('=== ATTENDANCE RECORDS ===');
      console.log('Total records:', records.length);
      console.log('Records:', JSON.stringify(records, null, 2));
      
      setAttendance(records);
      
      // Calculate stats: count how many members from the members list have attendance records
      const presentCount = members.filter(member => {
        const record = records.find(r => parseInt(r.memberId) === parseInt(member.id));
        const isPresent = record && record.checkInTime;
        
        console.log(`Member: ${member.name} (ID: ${member.id})`);
        console.log('  - Record found:', !!record);
        if (record) {
          console.log('  - checkIn:', record.checkIn);
          console.log('  - checkInTime:', record.checkInTime);
          console.log('  - Is Present:', isPresent);
        }
        
        return isPresent;
      }).length;
      
      const totalCount = members.length;
      const absentCount = totalCount - presentCount;
      
      console.log('=== STATS ===');
      console.log('Present:', presentCount);
      console.log('Absent:', absentCount);
      console.log('Total:', totalCount);
      
      setStats({ 
        present: presentCount, 
        absent: absentCount, 
        total: totalCount 
      });
    } catch (err) {
      console.error('Error fetching attendance:', err);
      setAttendance([]);
      setStats({ present: 0, absent: members.length, total: members.length });
    }
  };

  const markAttendance = async (memberId, type) => {
    try {
      if (type === 'in') {
        const response = await axios.post('/api/gym/attendance/checkin', { memberId, date });
        if (response.data.success) {
          alert('Check-in successful!');
          await fetchAttendance();
        } else {
          // If already checked in, just refresh to show the data
          console.log('Already checked in, refreshing data...');
          await fetchAttendance();
        }
      } else {
        const record = attendance.find(a => a.memberId === memberId);
        if (record?.id) {
          const response = await axios.post(`/api/gym/attendance/checkout/${record.id}`);
          if (response.data.success) {
            alert('Check-out successful!');
            await fetchAttendance();
          } else {
            alert(response.data.error || 'Failed to check-out');
          }
        } else {
          alert('No check-in record found for this member');
        }
      }
    } catch (err) {
      console.error('Error marking attendance:', err);
      // If error is 'already checked in', just refresh the data
      if (err.response?.data?.error?.includes('Already checked in')) {
        await fetchAttendance();
      } else {
        alert('Error: ' + (err.response?.data?.error || err.message || 'Failed to mark attendance'));
      }
    }
  };

  return (
    <Container fluid className="py-4">
      <Row className="mb-4">
        <Col><h2>✅ Gym Attendance</h2><p className="text-muted">Daily attendance tracking</p></Col>
        <Col xs="auto">
          <Form.Control 
            type="date" 
            value={date} 
            max={new Date().toISOString().split('T')[0]}
            onChange={(e) => setDate(e.target.value)} 
            style={{ width: '200px' }} 
          />
        </Col>
      </Row>

      <Row className="mb-4">
        <Col md={4}>
          <Card className="text-center" style={{ borderLeft: '4px solid #28a745' }}>
            <Card.Body>
              <h3 className="text-success">{stats.present}</h3>
              <p className="mb-0">Present Today</p>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="text-center" style={{ borderLeft: '4px solid #dc3545' }}>
            <Card.Body>
              <h3 className="text-danger">{stats.absent}</h3>
              <p className="mb-0">Absent Today</p>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="text-center" style={{ borderLeft: '4px solid #007bff' }}>
            <Card.Body>
              <h3 className="text-primary">{stats.total}</h3>
              <p className="mb-0">Total Active Members</p>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Card className="shadow-sm mb-3">
        <Card.Body>
          <InputGroup>
            <InputGroup.Text><FaSearch /></InputGroup.Text>
            <Form.Control placeholder="Search member..." value={search} onChange={(e) => setSearch(e.target.value)} />
          </InputGroup>
        </Card.Body>
      </Card>

      <Card className="shadow-sm">
        <Card.Body>
          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-success" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : members.length === 0 ? (
            <div className="text-center py-5">
              <h5 className="text-muted">No active members found</h5>
              <p>Add members first to track attendance</p>
            </div>
          ) : (
            <Table responsive hover>
              <thead>
                <tr>
                  <th>Member ID</th>
                  <th>Member Name</th>
                  <th>Phone</th>
                  <th>Check-in</th>
                  <th>Check-out</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {members.filter(m => !search || m.name.toLowerCase().includes(search.toLowerCase()) || m.phone.includes(search)).map((member) => {
                  const record = attendance.find(a => parseInt(a.memberId) === parseInt(member.id));
                  const hasCheckedIn = record && record.checkInTime;
                  const hasCheckedOut = record && record.checkOutTime;
                  
                  return (
                    <tr key={member.id}>
                      <td><strong>{record?.memberCode || member.memberId}</strong></td>
                      <td>{member.name}</td>
                      <td>{member.phone}</td>
                      <td>{record?.checkIn || (record?.checkInTime ? new Date(record.checkInTime).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true }) : '-')}</td>
                      <td>{record?.checkOut || (record?.checkOutTime ? new Date(record.checkOutTime).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true }) : '-')}</td>
                      <td>
                        {hasCheckedIn ? (
                          <Badge bg="success">Present</Badge>
                        ) : (
                          <Badge bg="secondary">Absent</Badge>
                        )}
                      </td>
                      <td>
                        {!hasCheckedIn ? (
                          <Button variant="success" size="sm" onClick={() => markAttendance(member.id, 'in')}>
                            <FaCheckCircle className="me-1" /> Check In
                          </Button>
                        ) : !hasCheckedOut ? (
                          <Button variant="warning" size="sm" onClick={() => markAttendance(member.id, 'out')}>
                            <FaTimesCircle className="me-1" /> Check Out
                          </Button>
                        ) : (
                          <Badge bg="info">Completed</Badge>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
};

export default GymAttendance;
